<script setup lang="ts">
  import { formatTrainingControlValue } from '../../lib/formatTrainingControlValue';

  defineProps<{
    title: string | null;
  }>();
</script>

<template>
  <section
    data-testid="training-control-section-title"
    class="flex flex-col gap-2 border-b border-gray-02 px-6 py-8"
  >
    <span class="text-xs font-semibold text-gray-07">Título do Treinamento</span>
    <span
      data-testid="training-control-title"
      class="rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm text-gray-07"
    >
      {{ formatTrainingControlValue(title) }}
    </span>
  </section>
</template>
